export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION = {
  GENERADO : 'generado',
  PENDIENTE : 'pendiente',
  APROBADA : 'aprobada',
  RECHAZADA : 'rechazada',
  OBSERVADO : 'observado',
};
// -- modificado 
export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS = {
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE]: 'Pendiente',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO]: 'Generado',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.APROBADA]: 'Aprobada',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADA]: 'Rechazada',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.OBSERVADO]: 'Observado',
};

export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_COLORES = {
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE]: 'orange',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO]: 'primary',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.APROBADA]: 'success',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADA]: 'red',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.OBSERVADO]: 'teal',
};

export const ESTADOS_SOLICITUD_CALIFICACION_NIVELACION = {
  GENERADO: 'generado',
  PENDIENTE: 'pendiente',
  APROBADO: 'aprobado',
  RECHAZADO: 'rechazado',
};

export const ESTADOS_SOLICITUD_CALIFICACION_NIVELACION_LABELS = {
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.GENERADO]: 'Generado',
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.PENDIENTE]: 'Pendiente',
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.APROBADO]: 'Aprobado',
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.RECHAZADO]: 'Rechazado',
};

export const ESTADOS_SOLICITUD_CALIFICACION_NIVELACION_COLORES = {
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.GENERADO]: 'primary',
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.PENDIENTE]: 'orange',
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.APROBADO]: 'success',
  [ESTADOS_SOLICITUD_CALIFICACION_NIVELACION.RECHAZADO]: 'red',
};

export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LIST = [
  { value: null, text: 'Todos' },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.APROBADA,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.APROBADA],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADA,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADA],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.OBSERVADO,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.OBSERVADO],
  },
];
